/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Origin_SourceInputs */

const en_road_dude_origin_source = /** @type {(inputs: Road_Dude_Origin_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch Bird28thegr8’s original clip`)
};

const zh_road_dude_origin_source = /** @type {(inputs: Road_Dude_Origin_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观看 Bird28thegr8 的原视频`)
};

/**
* | output |
* | --- |
* | "Watch Bird28thegr8’s original clip" |
*
* @param {Road_Dude_Origin_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_origin_source = /** @type {((inputs?: Road_Dude_Origin_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Origin_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_origin_source(inputs)
	return zh_road_dude_origin_source(inputs)
});
export { road_dude_origin_source as "road_dude.origin.source" }